export const AUTH_SUCCESS = 'AUTH_SUCCES'
export const AUTH_ERROR = 'AUTH_ERROR'
export const CODE_SUCCESS = 'CODE_SUCCESS'
export const CODE_ERROR = 'CODE_ERROR'
export const LOGOUT_USER = 'LOGOUT_USER'
export const REFETCH_HOMES = 'REFETCH_HOMES'
export const SET_CURRENT_HOME = 'SET_CURRENT_HOME'
